import { URLS, Url } from '@wix/da-url';
export function useSubmitUrl(openSubmit = false) {
    if (openSubmit) {
        return Url.submitStudio(openSubmit);
    }
    return URLS.STUDIO;
}

//# sourceMappingURL=useSubmitUrl.js.map